import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { ILoteAgendamentoCadastroForm } from "../../../../types/loteAgendamento";

export const useCadastrarLoteAgendamento = () => {
  return useMutation({
    mutationFn: (data: ILoteAgendamentoCadastroForm) =>
      LoteAgendamento.cadastrar(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
